import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/features")({
  staticData: { title: "Features" },
  component: FeaturesPage,
});

function FeaturesPage() {
  return (
    <div>
      <h1>Features</h1>
    </div>
  );
}
